module.exports = __webpack_public_path__ + "img/divider.a8cce258.svg";